import { render, staticRenderFns } from "./KeyWords.vue?vue&type=template&id=37a424e6&lang=pug"
import script from "./KeyWords.vue?vue&type=script&lang=js"
export * from "./KeyWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports